import React, { useEffect, useCallback, useState} from 'react';
import {savePad} from 'packs/packs.js';
import {connect} from 'react-redux';

const SavePad = ({hide, pad}) => { 
    let [name, setName] = useState('');

    const onSave = useCallback(() => {
        savePad(name, pad);
        hide();
    }, [name, hide, pad]);

    return (
        <div className="pads save-pad">
          <div className="pad-inner">
            <div>Save as Pack</div>
            <input
              value={name}
              type="text"
              className="pack-name"
              onChange={e => setName(e.target.value)}
              placeholder="Type name for pack"/>
            <div className="complete-buttons">
              <div onClick={onSave} className="done-btn">
                Done
              </div>
              <div onClick={hide} className="cancel-btn">
                Cancel
              </div>
            </div>
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SavePad);
